import { render, staticRenderFns } from "./LeftMenuItem.vue?vue&type=template&id=5acb5b59"
import script from "./LeftMenuItem.ts?vue&type=script&lang=js&external"
export * from "./LeftMenuItem.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports